import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { AssetId } from '~modules/media-library/model/Asset';
import { ConfirmDeleteModalPanel } from '~modules/media-library/view/Contribute/ConfirmDelete/ConfirmDeleteModalPanel';

type ConfirmDeleteModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onDeleteSuccess: () => void;
  assetId: AssetId;
};

export function ConfirmDeleteModal({ isOpen, onClose, onDeleteSuccess, ...PanelProps }: ConfirmDeleteModalProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog onClose={onClose} as="div" className="relative z-40">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-50"
          leave="ease-in duration-200"
          leaveFrom="opacity-50"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black opacity-50" />
        </Transition.Child>
        <div className="fixed inset-0 p-8 flex justify-center items-center overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95 translate-y-4"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95 translate-y-4"
          >
            <Dialog.Panel
              as={ConfirmDeleteModalPanel}
              {...PanelProps}
              onClose={onClose}
              onDeleteSuccess={onDeleteSuccess}
              className="transition-all transform"
            />
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}
